<template>
    <div class="top-posts-slider overflow-hidden">
        <div class="flex flex-col gap-4">
            <div class="swiper-wrapper flex flex-row gap-4" ref="wrapper">
                <TeamPortraitsItem
                    v-for="(member, index) in members"
                    :key="member.last_name"
                    ref="slide"
                    class="bg-white shadow-md rounded-md transition-all ease-in-out duration-500"
                    :class="[activeTopPost === member.totalIndex ? widthActive : widthUnactive, slideClasses]"
                    :active="activeTopPost === member.totalIndex"
                    @mouseover="$emit('update:activeTopPost', member.totalIndex)"
                    :member="member"
                    :height="height"
                    :position="member.rowIndex === 0 ? 'firstSlide' : member.rowIndex === members.length - 1 ? 'lastSlide' : 'middleSlide'"
                    :memberAmount="mobileCarousel === false ? 0 : members.length"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Swiper, { Navigation } from 'swiper';

Swiper.use([Navigation]);

export default {
    props: ['activeTopPost', 'images', 'members', 'widthActive', 'widthUnactive', 'height', 'mobileCarousel'],

    emits: ['update:activeTopPost'],

    data: () => ({
        slider: null,
        listener: null,
        breakpoint: null,
        slideClasses: null
    }),

    methods: {
        breakpointChecker() {
            if (this.mobileCarousel || this.mobileCarousel === undefined) {
                if (this.breakpoint.matches === true) {
                    this.$refs.wrapper.classList.remove('swiper-wrapper');
                    this.$refs.wrapper.classList.add('flex', 'flex-row', 'gap-4');
                    this.slideClasses = null;

                    if (this.slider != null) {
                        this.slider;
                    }
                    return;
                } else if (this.breakpoint.matches === false) {
                    this.$refs.wrapper.classList.add('swiper-wrapper');
                    this.$refs.wrapper.classList.remove('flex', 'flex-row', 'gap-4');
                    this.slideClasses = 'swiper-slide';

                    this.slider = new Swiper('.top-posts-slider', {
                        slidesPerView: 1,
                        loop: false,
                        grabCursor: true
                    });
                    return;
                }
            } else {
                if (this.breakpoint.matches === true) {
                    this.$refs.wrapper.classList.remove('swiper-wrapper', 'flex-col');
                    this.$refs.wrapper.classList.add('flex', 'flex-row', 'gap-4');
                    this.slideClasses = null;

                    if (this.slider != null) {
                        this.slider;
                    }
                    return;
                } else if (this.breakpoint.matches === false) {
                    this.$refs.wrapper.classList.add('flex-col');
                    this.$refs.wrapper.classList.remove('flex-row');
                    return;
                }
            }
        }
    },

    mounted() {
        this.breakpoint = window.matchMedia(`(min-width:${this.$tw.theme.screens.lg})`);
        this.breakpointChecker();
        window.addEventListener('resize', this.breakpointChecker);
    },

    beforeUnmount() {
        window.removeEventListener('resize', this.breakpointChecker);
    }
};
</script>
